import { cn } from "@/lib/utils";

/**
 * A loading placeholder.
 *
 * It renders no number and no text: a skeleton is the honest rendering of "not
 * loaded yet". prefers-reduced-motion is handled globally in index.css, which
 * stills the pulse.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
